"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importDefault(require("react"));
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const DialogBody = (_a) => {
    var { className, children } = _a, remainingProps = tslib_1.__rest(_a, ["className", "children"]);
    const classes = (0, classnames_1.default)('modal-body', className);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({}, remainingProps, { className: classes }, { children: children })));
};
DialogBody.defaultProps = {
    className: '',
};
DialogBody.propTypes = {
    className: prop_types_1.default.string,
};
exports.default = DialogBody;
